export default {
    search_placeholder: "Search...",
    showing_results: "Showing {0} result",
    showing_results_plural: "Showing {0} results",
};
